import React, {useEffect, useMemo, useState} from "react";
import {CodeSpecNum} from "../../../../../constant/CodeSpecNum";
import Search from "../../../../../components/search/Search";
import {SearchComboBox} from "../../../../../components/select/SearchComboBox";
import {ASSET_EOS_LIST_HEADER} from "../../../../../components/table/header/Headers";
import SearchSection from "../../../../../components/search/SearchSection";
import Selector from "../../../../../components/selector/Selector";
import {searchWithChildren} from "../../../../../components/commonmethod/simmsDrawerMethod";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, nonObject, simmsColumnsToJsGridHeaders} from "../../../../../components/commonmethod/CommonMethod";
import SimmsInputSearch from "../../../../../components/input/SimmsInputSearch";
import SimmsJsGrid from "../../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../components/pageTabs/pageTabsStorage";
import {useNavigate} from "react-router-dom";
import {useExcelDownloadClick} from "../../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../../components/js-grid/JsGridExcelGridOpenButton";
const eosType = [
    {id: "1", name: "EOS 만료도래 1개월 전"},
    {id: "2", name: "EOS 만료도래 3개월 전"},
    {id: "3", name: "EOS 기간만료"},
];

function AssetEosListType({data, date, pageInfo, dataHook}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: ASSET_EOS_LIST_HEADER, exclude: []});

    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, ASSET_EOS_LIST_HEADER, setHeader, [], () => {}, () => {}, 'eos');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "자산상세"),
            url: `/asset/${id}`,
        });
    };

    const eosJsGridHeader = useMemo(() => {
        const converted = simmsColumnsToJsGridHeaders(header);
        if (converted.length > 0) return converted;
        return simmsColumnsToJsGridHeaders({order: ASSET_EOS_LIST_HEADER, exclude: []});
    }, [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'eos'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} size detail date={searchDate} searchBar={{placeHolder: '자산명, 자산코드'}}>
                <SearchSection>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'group', extractObject(saveConditions), value)}
                                 data={saveConditions.group}
                                 parentKey={CodeSpecNum.AssetGroupCode} recursive
                                 entity={"code"} title={"자산그룹"} />
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'task', extractObject(saveConditions), value)}
                                 data={saveConditions.task}
                                 parentKey={CodeSpecNum.TaskGroupCode} recursive
                                 entity={"code"} title={"업무그룹"} />
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'location', extractObject(saveConditions), value)}
                                 data={saveConditions.location}
                                 parentKey={CodeSpecNum.AssetLocation} recursive
                                 entity={"code"} title={"자산위치"} />
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'project', extractObject(saveConditions), value)}
                                 data={saveConditions.project}
                                 entity={"project"} title={"시스템"}>
                        <SimmsInputSearch type={'TEXT'} placeHolder={"시스템"} />
                    </Selector>
                    <SearchComboBox title={"EOS 만료일"} code={eosType} target={"dateType"} value={saveConditions}
                                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "dateType")}
                    />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={eosJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {eos: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'eos')}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="ExcelEosDto" search={excelGridSearch} />
                        </div>
                    )}
                />
            </div>
        </div>
    );
}
export {AssetEosListType};
